<template>
    <v-tour 
        name="payment_method_tour" 
        :steps="tourSteps" 
        :options="tourOptions" 
        :callbacks="tourCallbacks"
    ></v-tour>
</template>

<script>
export default {
        name:"PaymentMethodTour",
    data(){
        return  {
            tourSteps:[
                {
                    target: '#tour-start-btn',
                    content: `<strong>Start Tour</strong><br>Provides insights into the available functionalities within a specific menu, helping you understand what actions you can perform.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement: 'bottom'
                    }
                },
                {
                    target: '#master-search',
                    content: `<strong>Master Search</strong><br>Enables you to perform searches from all over the dashboard.`,
                    params: {
                        highlight: true,
                        enableScrolling: false
                    },
                },
                {
                    target: '#add-new-dropDown',
                    content: `<strong>Add New Record</strong><br>Enables you to add new orders, products and categories on the go.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                    }
                },
                {
                    target: '#help-link',
                    content: `<strong>Help</strong><br>If you require any assistance, feel free to reach out to us.`,
                    params: {
                        highlight: true,
                        enableScrolling: false
                    }
                },
                {
                    target: '#user-options-dropdown',
                    content: `<strong>User Information</strong><br>Presents essential details about you along with a selection of available options.`,
                    params: {
                        highlight: true,
                        enableScrolling: false
                    }
                },
                //payment method steps
                //COD payment method steps
                {
                    target: '#COD-step',
                    content: `<strong>Cash On Delivery</strong><br>COD payment method is available for the user.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#COD-step-status',
                    content: `<strong>Active/Disabled</strong><br>Status of the COD payment method can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                //alfalah payment method steps
                {
                    target: '#Alfalah-step',
                    content: `<strong>Alfalah Payment Gateway</strong><br>Bank Alfalah payment gateway is available for the user.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-step-status',
                    content: `<strong>Active/Disabled</strong><br>Status of the Alfalah payment gateway can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#Alfalah-form',
                    content: `<strong>Alfalah Payment Gateway</strong><br>Alfalah payment gateway can be enabled by filling the information in the available form.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-merchant-username',
                    content: `<strong>Merchant Username</strong><br>Merchant username can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-merchant-password',
                    content: `<strong>Merchant Password</strong><br>Merchant password can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-channel-id',
                    content: `<strong>Channel ID</strong><br>Channel Id can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-merchant-id',
                    content: `<strong>Merchant ID</strong><br>Merchant Id can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-store-id',
                    content: `<strong>Store ID</strong><br>Store Id can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-merchant-hash',
                    content: `<strong>Merchant Hash</strong><br>Merchant hash can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-key-one',
                    content: `<strong>Key One</strong><br>Key one can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-key-two',
                    content: `<strong>Key Two</strong><br>Key two can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#merchantReturnUrl',
                    content: `<strong>Return URL</strong><br>You've to use this return URL in Alfalah Merchant portal to generate the credentials.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#alfalah-save-btn',
                    content: `<strong>Save Details</strong><br>Alfalah payment gateway details can be saved by clicking this button.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                //stripe payment method steps
                {
                    target: '#stripe-step',
                    content: `<strong>Stripe Payment Gateway</strong><br>Stripe payment gateway is available for the user.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#stripe-step-status',
                    content: `<strong>Active/Disabled</strong><br>Status of the Stripe payment gateway can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#stripe-form',
                    content: `<strong>Stripe Payment Gateway</strong><br>Stripe payment gateway can be enabled by filling the information in the available form.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#stripe-publishable-key',
                    content: `<strong>Stripe Publishable Key</strong><br>Stripe publishable key can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#stripe-secret-key',
                    content: `<strong>Stripe Secret Key</strong><br>Stripe secret key can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#stripe-save-btn',
                    content: `<strong>Save Details</strong><br>Stripe payment gateway details can be saved by clicking this button.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                //paypal payment method steps
                {
                    target: '#paypal-step',
                    content: `<strong>Paypal Payment Gateway</strong><br>Paypal payment gateway is available for the user.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-step-status',
                    content: `<strong>Active/Disabled</strong><br>Status of the Paypal payment gateway can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-form',
                    content: `<strong>Paypal Payment Gateway</strong><br>Paypal payment gateway can be enabled by filling the information in the available form.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-client-id',
                    content: `<strong>Paypal Client ID</strong><br>Paypal client id can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-client-secret',
                    content: `<strong>Paypal Client Secret</strong><br>Paypal client secret can be added in this field.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-environment-toggle',
                    content: `<strong>Environment Toggle</strong><br>Credential Environment of the Paypal payment gateway can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#paypal-save-btn',
                    content: `<strong>Save Details</strong><br>Paypal payment gateway details can be saved by clicking this button.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                //bank transfer payment method steps
                {
                    target: '#bank-transfer-step',
                    content: `<strong>Bank Transfer</strong><br>Bank Transfer Details can be added using this form.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#bank-transfer-step-status',
                    content: `<strong>Active/Disabled</strong><br>Status of the bank transfer payment method can be changed using this option.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#bank-transfer-form',
                    content: `<strong>Bank Transfer</strong><br>Bank details can be added by filling the information in the available form.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#bank-transfer-add-bank-btn',
                    content: `<strong>Add Bank Details</strong><br>More bank details can be added by clicking this button.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
                {
                    target: '#bank-transfer-save-btn',
                    content: `<strong>Save Details</strong><br>Bank transfer details can be saved by clicking this button.`,
                    params: {
                        highlight: true,
                        enableScrolling: false,
                        placement:"bottom"
                    }
                },
            ],
            tourOptions: {
                useKeyboardNavigation: false,
                labels: {
                    buttonSkip: 'Skip Tour',
                    buttonPrevious: 'Previous',
                    buttonNext: 'Next',
                    buttonStop: 'Finish Tour'
                }
            },
            tourCallbacks: {
                onPreviousStep: this.handlePreviousStep,
                onNextStep: this.handleNextStep,
                // onStart: this.handleTourStart,
                onStop: this.handleTourStop,
                onFinish: this.handleTourFinish,
                onSkip: this.handleTourSkip
            },
        }
    },
    components:{
    },
    computed:{
    },
    watch:{
    },
    methods:{

        startTour(){
            
            this.$tours.payment_method_tour.start();

        },
        handleNextStep(currentStep){

            if(currentStep + 1 == 9){

                this.$parent.alfalahPaymenthMethod.isActive = true;

            }

            if(currentStep + 1 == 22){

                this.$parent.stripePaymentMethod.isActive = true;

            }

            if(currentStep + 1 == 28){

                this.$parent.paypalPaymentMethod.isActive = true;

            }

            if(currentStep + 1 == 34){

                this.$parent.bankTransferPaymentMethod.isActive = true;

            }
            
        },
        handlePreviousStep(currentStep){

            if(currentStep == 9){

                this.$parent.alfalahPaymenthMethod.isActive = false;

            }

            if(currentStep == 22){

                this.$parent.stripePaymentMethod.isActive = false;

            }

            if(currentStep == 28){

                this.$parent.paypalPaymentMethod.isActive = false;

            }

            if(currentStep == 34){

                this.$parent.bankTransferPaymentMethod.isActive = false;

            }

        },
        handleTourStop(){

            if(this.$tours.payment_method_tour.currentStep != -1){

                this.$parent.loadPaymentMethods();

            }

        },
        handleTourFinish(){

            if(this.$tours.payment_method_tour.currentStep != -1){

                this.$parent.loadPaymentMethods();

            }

        },
        handleTourSkip(){

            if(this.$tours.payment_method_tour.currentStep != -1){

                this.$parent.loadPaymentMethods();

            }

        },

    },
}
</script>

<style>

</style>